// extracted by mini-css-extract-plugin
export default {"flex":"DashboardEditDrawer_flex__jzDuq","inputName":"DashboardEditDrawer_inputName__LVNo0","deleteButton":"DashboardEditDrawer_deleteButton__1AD5t"};